/**
 * Normalização da busca (§5.8.2, M25): sem acento nem cedilha, minúsculas, apóstrofos somem, hífens e travessões viram
 * espaço, espaços repetidos viram um. "Pau D'Arco", "pau-d'arco" e "pau darco" dão a mesma chave.
 */
export function normalizeSearch(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/['’‘`´]/g, '')
    .replace(/[-‐-―]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * As chaves de um nome (§5.8.2): a normalizada e a variante com o apóstrofo trocado por espaço ("Santa Bárbara d'Oeste"
 * casa "santa barbara doeste" e "santa barbara d oeste"). Sem repetição.
 */
export function searchKeys(name: string): string[] {
  const a = normalizeSearch(name);
  const b = normalizeSearch(name.replace(/['’‘`´]/g, ' '));
  return a === b ? [a] : [a, b];
}
